import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useParams, useRouteMatch } from 'react-router-dom'

import { Breadcrumb } from 'react-breadcrumbs'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { CityPlanCreateWrapper } from 'Components/Campaigns/CityPlanCreate/CityPlanCreateWrapper'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { PageTitle } from 'Components/PageTitle'
import { Checkbox } from 'Components/Form/Checkbox'
import { CreateCityPlanForm } from 'Containers/Form/Campaigns/CreateCityPlan'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'

import { createCityPlan } from 'Module/graphQL'
import useGraphQLFetch from 'Utils/Hooks/useGraphQLFetch'
import { PATHS } from 'Config/Routing/paths'
import CampaignsIcon from 'Assets/Images/icons/campaigns'
import {
  showReduxModal,
  toggleConfirmAvailabilityReduxModal,
} from 'Reducers/UI/actions'
import getCityPlanCreateData from './gql'
import { formatData } from './util'
import {
  AMBASSADOR_PER_MISSION,
  HOURS_PER_MISSION,
} from '../../../shared/constants'

const ConfirmationModalBody = ({
  formData: { distributionCost, payout, clientMarginPercent, hourlyPayout },
  missionType,
}) => {
  const dispatch = useDispatch()
  return (
    <section className="redux-modal">
      <article>
        <p>
          This data (and more) will be set for all NEWLY PUBLISHED missions:
        </p>
        <br />
        {missionType === AMBASSADOR_PER_MISSION && (
          <ul>
            <li>BA surge payout: {payout}</li>
            <li>Distribution cost: {distributionCost}</li>
          </ul>
        )}
        {missionType === HOURS_PER_MISSION && (
          <ul>
            <li>BA hourly pay: {hourlyPayout}</li>
            <li>Client margin percent: {clientMarginPercent}%</li>
          </ul>
        )}
      </article>
      <footer className="redux-modal__footer">
        <Checkbox
          input={{
            onClick: () => dispatch(toggleConfirmAvailabilityReduxModal()),
          }}
        />
        <span className="redux-modal__checkbox-hint">
          I understand changing these values will only affect NEWLY PUBLISHED
          missions
        </span>
      </footer>
    </section>
  )
}

const BreadcrumbsCreateCityPlan = ({
  campaignName,
  campaignId,
  currentPath,
}) => (
  <div>
    <Breadcrumbs icon={<CampaignsIcon style={{ width: 16 }} />} />
    <Breadcrumb
      data={{
        title: 'Campaigns',
        pathname: `${PATHS.main.dashboard}${PATHS.dashboard.campaigns}`,
      }}
    />
    <Breadcrumb
      data={{
        title: campaignName,
        pathname: `${PATHS.main.dashboard}${
          PATHS.dashboard.campaigns
        }/${campaignId}/city-plans`,
      }}
    />
    <Breadcrumb
      data={{
        title: 'Create a City Plan',
        pathname: currentPath,
      }}
    />
  </div>
)

const CityPlanCreate = () => {
  const history = useHistory()
  const { campaignId } = useParams()
  const match = useRouteMatch()
  const dispatch = useDispatch()

  const { data, isLoaded } = useGraphQLFetch({
    fetchFn: getCityPlanCreateData,
    defaultFetchArgs: campaignId,
    mapResponse: formatData,
  })

  if (!isLoaded) return 'Loading...'

  const { campaign, uniqueCitiesList } = data

  /**
   * Create city plan form submit handler
   *
   * @param values
   */
  const createCityPlanSubmitHandler = values => {
    const formData = {
      payout: values.payout,
      hourlyPayout: values.hourlyPayout,
      distributionCost: values.distributionCost,
      clientMarginPercent: values.clientMarginPercent,
      cityId: values.citySelect,
    }

    dispatch(
      showReduxModal({
        title: 'Confirmation needed',
        onConfirm: async () => {
          try {
            await createCityPlan({ campaignId, ...formData })
            createCityPlanSubmitSuccessHandler()
          } catch (error) {
            console.error(error)
          }
        },
        children: (
          <ConfirmationModalBody
            formData={formData}
            missionType={values.missionType}
          />
        ),
        confirmDisabled: true,
        confirmLabel: `Confirm`,
      }),
    )
  }

  const createCityPlanSubmitSuccessHandler = () => {
    history.push(
      `${PATHS.main.dashboard}${
        PATHS.dashboard.campaigns
      }/${campaignId}/city-plans`,
    )
  }

  return (
    <CityPlanCreateWrapper>
      <LayoutDashboard>
        <HideWhenBlocked>
          <BreadcrumbsCreateCityPlan
            campaignName={campaign.name}
            campaignId={campaignId}
            currentPath={match.url}
          />
          <PageTitle>Create City Plan</PageTitle>
          <CreateCityPlanForm
            campaign={campaign}
            cities={uniqueCitiesList}
            onSubmit={createCityPlanSubmitHandler}
          />
        </HideWhenBlocked>
      </LayoutDashboard>
    </CityPlanCreateWrapper>
  )
}

export default CityPlanCreate



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/CityPlanCreate/index.js